<template>
        <div class="noData">
            <p>
                <img src="//assets.lepucdn.cn/vuetest/images/fangke/none_03.png" alt="">
            </p>
            <p>无数据~</p>
        </div>
</template>
<script>
    export default {
        name: "nodata",
        data(){
            return{

            }
        }
    }
</script>
<style lang="scss" scoped>
.noData{
    position: fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p{
        img{
            width: 3.1rem;
            height: 4rem;
        }

        &:nth-last-child(1){
            line-height: .7rem;
            color: #666666;
            font-size: .26rem;
            padding-left: .3rem;
            box-sizing: border-box;
        }
    }
}
</style>